// extracted by mini-css-extract-plugin
export default {"projectPage":"ProjectPage_projectPage__Ty4If","pageTitle":"ProjectPage_pageTitle__QNcEH"};